import React, { useEffect, useState } from 'react'
import Table from "components/common/CustomTable";
import {
  FormGroup,
  Input,
  Row,
  Col,
  Button,
} from "reactstrap";
import customerApi from 'api/customer';
import useApi from '../../hooks/useApi';
import Spinner from '../Spinner';
import Pagination from 'components/common/Pagination';
import { useRouteMatch } from "react-router-dom";
import getCulture from "utils/getCulture";
import content from "components/common/content";

function PopupTable({ setCustomer, setTableModal, setValue, sweetAlert, multiple = false, customer = [] }) {
  const rout = useRouteMatch();
  const culture = getCulture(rout.url);
  // States
  const [data, setData] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [client, setClient] = useState('');
  const [shipmentNo, setShipmentNo] = useState('');
  const [docsPerPage, setDocsPerPage] = useState(5);
  
  // Apis
  const customers = useApi(customerApi.getAllCustomers);
  const findByName = useApi(customerApi.getByColumn);

  const getAllCustomers = async () => {

    const res = await customers.request(pageNo, docsPerPage);

    if (res.status === 200)
      setData(res.data.data)
  }

  const findClientByName = async () => {

    if (!client.trim()) return getAllCustomers();
    const res = await findByName.request("customerCode", client, pageNo, docsPerPage);
    if (res.status === 200) {
      setData(res.data.data)
    }
  }

  const handleSelect = obj => {
    // if multipe is true the 'customer' state should be an array to store multiple customers
    if (multiple) {
      setCustomer(customer => [...customer, obj]);
    } else {
      // otherwise store an object with the customer
      setCustomer(obj);
      setTableModal(false);
      setValue("client", obj.customerName)
    }
  }

  // this function render approve icon
  // if multiple attribute is true that means you can select multliple customers
  // always shows approve icon if the multiple if false
  // if multiple is true toggle approve icon with 'x'
  const renderApprove = !multiple ? () => true : child => {
    return !customer.find(user => user.id === child.id)
  }

  // this function render 'x' icon
  // but this will only call if multiple is false
  const renderCancel = child => {
    return customer.find(user => user.id === child.id)
  }

  const handleUnselect = obj => {
    setCustomer(customers => customers.filter(cus => cus.id !== obj.id))
  }

  useEffect(() => {
    if (client.trim().length) findClientByName();
    if (shipmentNo.trim().length) findClientByName();
    else getAllCustomers();
  }, [pageNo, docsPerPage, multiple && shipmentNo])

  useEffect(() => (customers.error && customers.data) && sweetAlert(customers.data ,true), [customers.data])
  useEffect(() => (findByName.error && findByName.data) && sweetAlert(findByName.data ,true), [findByName.data])

  return (
    <div>
      {customers.loading ? <Spinner
        gate="#29bb64"
        bg="#fff"
      />
      : <>
      {!multiple ? 
        <div className='padding-around pb-0'>
          <Row>
            <Col md="6">
              <FormGroup>
                <label
                  className="form-control-label"
                  htmlFor="customer-code"
                >
                  {content.customerCode[culture]}
                </label>
                <Input
                  id="customer-code"
                  placeholder={content.search[culture]}
                  type="text"
                  value={client}
                  onChange={e => setClient(e.target.value) }
                  onKeyPress={(e) => e.key === 'Enter' && findClientByName()}
                />
              </FormGroup>
            </Col>
            <span style={{paddingTop: 7}}>
              <Button 
                color="success" 
                type="button"
                className='mt-4'
                onClick={findClientByName}
              >
                <span className="btn-inner--icon me-1">
                  <i className="fas fa-search" />
                </span>
                <span>
                  {content.search[culture]}
                </span>
              </Button>
            </span>
          </Row>
        </div>
      : 
        <FormGroup>
          <label
            className="form-control-label"
            htmlFor="example3cols1Input"
          >
            {content.orderNumber[culture]}
          </label>
          <Input
            id="example3cols1Input"
            placeholder={content.search[culture]}
            type="text"
            value={shipmentNo}
            onChange={e => setShipmentNo(e.target.value) }
          />
        </FormGroup>
      }
      {multiple && 
        <ul className='popup-customer-list'>
          {customer.map(user => (
            <li 
              key={user.cusId}
            >
              <i className="fas fa-times hover-danger" onClick={handleUnselect.bind(null, user)} />
              {user.cusName}
            </li>
          ))}
        </ul>
      }
      <Pagination 
        dataLength={data.length}
        pageNo={pageNo} 
        setPageNo={setPageNo} 
        docsPerPage={docsPerPage} 
        setDocsPerPage={setDocsPerPage}
      >
        <Table
          headers={[content.actions[culture], content.name[culture], content.code[culture]]}
          columns={["customerName", "customerCode"]}
          data={data}
          setData={setData}
          renderCancel={renderCancel}
          handleSelect={handleSelect}
          renderApprove={renderApprove}
          handleUnselect={handleUnselect}
          isPrint={false}
        >
          <span className="me-1" fun="handleSelect" condition="renderApprove">
            <div id="approve" className="table-action cursor-pointer">
              <i className="fas fa-check fa-lg hover-info"></i>
            </div>
          </span>
          <span className="me-1" fun="handleUnselect" condition="renderCancel">
            <div id="remove" className="table-action cursor-pointer">
              <i className="fas fa-times fa-lg hover-danger padding-half" />
            </div>
          </span>
        </Table>
      </Pagination>
      </>}
    </div>
  )
}

export default PopupTable